import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-302">
      <div className="max-w-4xl mx-auto text-center" data-id="element-303">
        <div className="inline-flex items-center gap-2 border border-[#FFD700]/50 text-[#FFD700] font-bold text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-304">
          🏆 Sistema N°1 para Catequistas y Docentes de Religión en Argentina
        </div>

        <h2 className="text-4xl sm:text-5xl font-black text-white mb-4" data-id="element-305">
          ✝️ PROFEPACK™
        </h2>
        <h3 className="text-2xl sm:text-3xl font-bold text-[#FFD700] mb-6" data-id="element-306">
          MEGAPACK CATEQUESIS LISTO
        </h3>
        <p className="text-white text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-307">
          <strong data-id="element-308">
            12 Tomos + 6 Bonos — Primaria y Secundaria — Todo resuelto.
          </strong>
          <br data-id="element-309" />
          720+ páginas de contenido pedagógico y formativo completo.
          Planificación anual por nivel lista para presentar. Recursos listos
          para usar desde hoy.
        </p>

        <div className="relative mx-auto mb-10 max-w-3xl" data-id="element-310">
          <div className="grid grid-cols-6 gap-2 justify-center mb-2" data-id="element-311">
            {[{
            color: '#1565C0',
            label: '1°'
          }, {
            color: '#2E7D32',
            label: '2°'
          }, {
            color: '#E6A800',
            label: '3°'
          }, {
            color: '#E65100',
            label: '4°'
          }, {
            color: '#6A1B9A',
            label: '5°'
          }, {
            color: '#BF360C',
            label: '6°'
          }].map((tomo, i) => <div key={`primaria-${i}`} className="aspect-[4/5] rounded-xl shadow-2xl flex items-end justify-center pb-3 px-1" style={{
            backgroundColor: tomo.color,
            border: '2px solid #FFD700'
          }} data-id="element-312">
                <span className="text-white text-sm sm:text-base font-bold text-center" style={{
              textShadow: '0 1px 3px rgba(0,0,0,0.8)'
            }} data-id="element-313">
                  {tomo.label}
                </span>
              </div>)}
          </div>
          <div className="grid grid-cols-6 gap-2 justify-center" data-id="element-314">
            {[{
            color: '#00695C',
            label: '1°'
          }, {
            color: '#1565C0',
            label: '2°'
          }, {
            color: '#E65100',
            label: '3°'
          }, {
            color: '#C62828',
            label: '4°'
          }, {
            color: '#37474F',
            label: '5°'
          }, {
            color: '#4E342E',
            label: '6°'
          }].map((tomo, i) => <div key={`secundaria-${i}`} className="aspect-[4/5] rounded-xl shadow-2xl flex items-end justify-center pb-3 px-1" style={{
            backgroundColor: tomo.color,
            border: '2px solid #FFD700'
          }} data-id="element-315">
                <span className="text-white text-sm sm:text-base font-bold text-center" style={{
              textShadow: '0 1px 3px rgba(0,0,0,0.8)'
            }} data-id="element-316">
                  {tomo.label}
                </span>
              </div>)}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#FFD700] text-black font-black text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-317">
            12 TOMOS COMPLETOS
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 mt-8 max-w-4xl mx-auto" data-id="element-318">
          <span className="bg-[#FFD700]/10 text-[#FFD700] text-xs font-bold px-3 py-2 rounded-lg text-center" data-id="element-319">
            ✅ 1° a 6° Primaria + 1° a 6° Secundaria
          </span>
          <span className="bg-[#FFD700]/10 text-[#FFD700] text-xs font-bold px-3 py-2 rounded-lg text-center" data-id="element-320">
            ✅ Unidades temáticas completas por nivel
          </span>
          <span className="bg-[#FFD700]/10 text-[#FFD700] text-xs font-bold px-3 py-2 rounded-lg text-center" data-id="element-321">
            ✅ Objetivos pedagógicos con criterio catequístico y docente
          </span>
          <span className="bg-[#FFD700]/10 text-[#FFD700] text-xs font-bold px-3 py-2 rounded-lg text-center" data-id="element-322">
            ✅ 100% contexto argentino — parroquia y colegio
          </span>
        </div>
      </div>
    </section>;
}